import { random, round2Str } from "../helpers/helpers";
import { thMeterSensorRegistry } from "./thMeterSensorRegistry";

export const generateThLineDemo = ({
                                       meter_id,
                                       sensor_name, // sensor_id
                                       start,
                                       end,
                                   }) => {
    const now = new Date();

    // -------------------------
    // Resolve meter & sensor
    // -------------------------
    const meterEntry = thMeterSensorRegistry.find(
        (m) => m.meter_id === Number(meter_id)
    );

    const sensorEntry = meterEntry?.sensors.find(
        (s) => s.sensor_id === Number(sensor_name)
    );

    const [minTemp, maxTemp] = sensorEntry?.temp_range || [18, 24];
    const [minHumi, maxHumi] = sensorEntry?.humi_range || [45, 60];

    // -------------------------
    // Time range
    // -------------------------
    const startTime = new Date(`${start} 00:00:00`);
    const endTimeRaw = new Date(`${end} 23:59:59`);

    // If today → stop at now
    const endTime =
        start === end &&
        new Date(start).toDateString() === now.toDateString()
            ? now
            : endTimeRaw;

    // -------------------------
    // Base values (smooth)
    // -------------------------
    let temp = random(minTemp + 1, maxTemp - 1);
    let humi = random(minHumi + 2, maxHumi - 2);

    const data = [];

    const cursor = new Date(startTime);

    while (cursor <= endTime) {
        // Gentle drift
        temp += random(-0.4, 0.4);
        humi += random(-0.8, 0.8);

        // Clamp
        temp = Math.max(minTemp - 2, Math.min(temp, maxTemp + 2));
        humi = Math.max(minHumi - 5, Math.min(humi, maxHumi + 10));

        // Rare humidity spike (realistic)
        if (Math.random() < 0.05) {
            humi += random(10, 20);
        }

        data.push({
            device_time: cursor
                .toISOString()
                .slice(0, 19)
                .replace("T", " "),
            temperature: round2Str(temp),
            humidity: round2Str(humi),
        });

        // +15 minutes
        cursor.setMinutes(cursor.getMinutes() + 15);
    }

    return data;
};
